import { Component, OnInit } from '@angular/core';
import { User } from '../../../../classes/User';
import { PROVINCES } from '../../../data/provinces';
import { ROLES } from '../../../data/roles';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';
import { GlobalService } from '../../../services/global.service';
import { AlertsService } from '../../../services/alerts.service';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})
export class AddUserComponent implements OnInit {

  isSubmitButtonDisabled: boolean = false;
  newUser: User = new User( );
  confirmPassword: string = '';

  provinces = PROVINCES;
  roles = ROLES;
  managers: any[] = [];

  user_active: boolean = true;
  
  customAdmins = [];

  availableRoles: string[] = [ 'admin' ];
  isAvailable: boolean = true;


  selectParams: any = {

    manager: {
      id: 'selectManager',
      isRequired: true,
      isDisabled: this.newUser.role == 'admin',
      change: ( event ) => { this.newUser.manager = event.value; },
      options: [ { text: '', value: '' } ]
    },
    
    role: {
      id: 'selectRole',
      isRequired: true,
      change: ( event ) => { 
        this.newUser.role = event.value; 
        this.selectParams.manager.isDisabled = event.value == 'admin';
      },
      options: [ { text: '', value: '' } ]
    },
    
    referredBy: {
      id: 'selectReferredBy',
      isRequired: true,
      change: ( event ) => { this.newUser.referredBy = event.value; },
      options: [ { text: '', value: '' } ]
    },

    state: {
      id: 'selectState',
      isRequired: true,
      change: ( event ) => { this.newUser.state = event.value; },
      options: [ { text: '', value: '' } ]
    }

  };

  constructor ( 
    private model: ModelService,
    public global: GlobalService,
    private alerts: AlertsService,
    private loginService: LoginService ) {
    this.global.setDocumentTitle( 'Add User' );
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;
  }

  ngOnInit ( ) { 

    this.provinces.forEach( _st => { this.selectParams.state.options.push( { text: _st.long, value: _st.short } ); });
    this.roles.forEach( _rl => { this.selectParams.role.options.push( { text: _rl.name, value: _rl.data } ); });

    this.getManagers( '' );
  }


  getManagers ( role: string ) {
    this.model.getCustomAdmins( ( customAdmins ) => { 
      let _referredBy = [ { text: '', value: '' } ];
      this.customAdmins = customAdmins; 
      customAdmins.forEach( _user => { _referredBy.push( { text: _user.firstName + ' ' + _user.secondName, value: _user.id } ); });
      this.selectParams.referredBy.options = _referredBy;
        
      // this.customAdmins = customAdmins; 
      // customAdmins.forEach( _user => { this.selectParams.referredBy.options.push( { text: _user.firstName + ' ' + _user.secondName, value: _user.id } ); });
    });
    this.model.getUsersData( ( usersData ) => {
      usersData = usersData.json( );
      this.managers = usersData.users;
      usersData.users.forEach( _user => { this.selectParams.manager.options.push( { text: _user.firstName + ' ' + _user.secondName, value: _user.id } ); });
    }, { user_role: role, manager: true, status: 'active', not_empty_name: 'true' });  
  }


  successCallback ( ) {
    this.global.defaultSuccessMessage({ 
      html: 'New user has been added successfully', 
      redirect: '/users-list' 
    });
  }


  errorCallback ( message? ) {
    let _message = ( message ) ? message : 'We got some error here';
    let data = {
      messageType: 'error',
      message: _message,
      title: ''
    }
    this.alerts.setData( data ).subscribe( );
    this.global.defaultErrorCallback( _message, false );
    this.isSubmitButtonDisabled = false;

  }

  errorPasswords ( ) {
    let data = {
      messageType: 'error',
      message: 'Passwords don\'t match',
      title: ''
    }
    this.alerts.setData( data ).subscribe( );
    this.global.defaultErrorCallback( 'Passwords don\'t match', false );
    this.isSubmitButtonDisabled = false;
  }


  submitForm ( ) {

    this.isSubmitButtonDisabled = true;
    if ( this.newUser.password != this.confirmPassword ) {
        this.errorPasswords( );
    } else {
      this.newUser.status = this.user_active ? 'active' : 'inactive';
      this.model.addUser( this.newUser, ( response ) => {
        let _answer = response.json( );
        _answer = _answer.answer;
        if ( _answer == 'success' ) this.successCallback( );
        else if ( _answer == 'exists' ) {
          this.errorCallback( 'User with email "'+this.newUser.email+'" already exists' );
        } else {
          this.errorCallback( );
        }
      });
    }
    return false;
  }

  cancelSubmit ( ) {
    this.global.redirect( '/users-list' );
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/users/add-user/add-user.component.ts